import { Breadcrumb, Button, ReportColumnWrapperDiv, ReportDetailWrapperDiv } from 'app/shared';
import { t } from 'i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useReportDetail } from 'app/hooks';
import { Box, Grid } from '@mui/system';
import { IReportStatus } from 'generated/axios';
import { isEmpty } from 'lodash';
import { useDialog } from 'app/context';
import { ReportDetailColumn } from './ReportDetailColumn';
import { ReportResultColumn } from './ReportResultColumn';
import { ReportImageColumn } from './ReportImageColumn';

export const ReportDetail = () => {
  const { reportId } = useParams();
  const { createSimpleConfirm } = useDialog();
  const navigate = useNavigate();

  const {
    detail,
    loading,
    updateForm,
    retryForm,
    photoBlisterUrl,
    getPatientSignature,
    getPhotoBlister,
    photoLoading,
    getPdf,
    deleteReport,
    confirmReport,
  } = useReportDetail(reportId as string);

  const { submit } = updateForm;

  //delete confirm
  const confirmDeleteDialog = () =>
    createSimpleConfirm({
      color: 'error.main',
      title: t('actions.delete'),
      message: t('reports.confirmDeleteMessage'),
      onConfirm: () => {
        deleteReport();
        navigate(-1);
      },
    });

  //complete confirm
  const confirmCompleteDialog = () =>
    createSimpleConfirm({
      title: t('actions.confirm'),
      message: t('reports.confirmCompleteMessage'),
      onConfirm: confirmReport,
    });

  return (
    <>
      <Breadcrumb />
      <ReportDetailWrapperDiv>
        <Grid container spacing={1}>
          <Grid size={4}>
            <ReportColumnWrapperDiv>
              <ReportDetailColumn
                detail={detail}
                loading={loading}
                navigate={navigate}
                updateForm={updateForm}
                getPatientSignature={getPatientSignature}
              />
            </ReportColumnWrapperDiv>
          </Grid>
          <Grid size={4}>
            <ReportColumnWrapperDiv>
              <ReportResultColumn detail={detail} loading={loading} updateForm={updateForm} />
            </ReportColumnWrapperDiv>
          </Grid>
          <Grid size={4}>
            <ReportColumnWrapperDiv>
              <ReportImageColumn
                detail={detail}
                imageUrl={photoBlisterUrl}
                loading={photoLoading}
                retryForm={retryForm}
                getPhotoBlister={getPhotoBlister}
              />
            </ReportColumnWrapperDiv>
          </Grid>
        </Grid>
        <Box padding={4} textAlign={'center'}>
          <Button loading={loading} onClick={submit} disabled={detail?.report_status === IReportStatus.Confirmed}>
            {t('actions.update')}
          </Button>
          <Button loading={loading} onClick={getPdf} color="secondary" disabled={!detail?.has_pdf}>
            {t('actions.downloadPdf')}
          </Button>
          <Button loading={loading} onClick={confirmDeleteDialog} color="error">
            {t('actions.delete')}
          </Button>
          <Button
            loading={loading}
            onClick={confirmCompleteDialog}
            color="success"
            disabled={
              isEmpty(detail?.patient) ||
              isEmpty(detail?.doctor) ||
              isEmpty(detail?.test_result) ||
              detail.report_status === IReportStatus.Error
            }
          >
            {t('actions.confirm')}
          </Button>
        </Box>
      </ReportDetailWrapperDiv>
    </>
  );
};
